import Event from '../../core/Event';
import State from '../State';
import initialState from '../initialState';
import CustomersReceived from '../events/CustomersReceived';
import CustomerUpdatedSucceed from '../events/CustomerUpdatedSucceed';
import EstimationPeriodUpdateSucceed from '../events/EstimationPeriodUpdateSucceed';
import EstimationPeriodsReceived from '../events/EstimationPeriodGetSucceed';
import updateUserSucceed from './updateCustomerSucceed';
import EstimationsRequestSucceed from '../../estimations/events/EstimationsRequestSucceed';

export default (state: State = initialState, anyEvent: Event): State => {
    switch (anyEvent.type) {
        case CustomersReceived.type: {
            return {
                ...state,
                customers: [...(anyEvent as CustomersReceived).customers]
            };
        }

        case CustomerUpdatedSucceed.type: {
            return updateUserSucceed(state, anyEvent as CustomerUpdatedSucceed);
        }
        case EstimationPeriodsReceived.type: {
            return {
                ...state,
                estimationPeriod: (anyEvent as EstimationPeriodsReceived).estimationPeriod
            };
        }
        case EstimationPeriodUpdateSucceed.type:
        case EstimationsRequestSucceed.type: {
            const event = anyEvent as EstimationPeriodUpdateSucceed;
            return {
                ...state,
                estimationPeriod: { ...event.estimationPeriod }
            };
        }
    }
    return state;
};



// WEBPACK FOOTER //
// ./src/application/admin/reducer/reducer.ts